export const fullscreen = {
    full: {
        text: "Plein écran",
        title: "Réduire la fenêtre de votre navigateur"
    },
    normal: {
        text: "Écran normal",
        title: "Mettre la fenêtre de votre navigateur en plein écran"
    }
}